/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";

const EditRate = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [customers, setCustomers] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [existingRates, setExistingRates] = useState([]);
    const [displayVehicles, setDisplayVehicles] = useState([]);

    const [form, setForm] = useState({
        customer_id: "",
        vehicle_id: "",
        lorry_type: "",
        normal_hrs: "",
        normal_hrs_ot: "",
        after_office_hrs: "",
        offz_hrs_ot: "",
        holiday: "",
        holiday_ot: "",
        gst_percent: 0
    });

    const loadInitialData = async () => {
        dispatch(loadingTrue());
        try {
            // 1. Load Customers
            const resCust = await Handler({ method: "get", url: "/customer/list.php?status=active&limit=1000" });
            if (resCust.success) {
                const activeCust = resCust.data.filter(c => c.status === "active" || c.is_active == 1);
                setCustomers(activeCust.map(c => ({ value: c.id, label: c.company_name })));
            }

            // 2. Load Vehicles
            const resVeh = await Handler({ method: "get", url: "/vehicle/list.php" });
            if (resVeh.success) {
                const activeVeh = resVeh.data.filter(v => v.status === "available" || v.is_active == 1);
                const formattedVehicles = activeVeh.map(v => ({
                    value: v.id,
                    label: `${v.vehicle_number} (${v.lorry_type})`,
                    lorry_type: v.lorry_type
                }));
                setVehicles(formattedVehicles);
                setDisplayVehicles(formattedVehicles);
            }

            // 3. Load All Rates
            const resRates = await Handler({ method: "get", url: "/rate/list.php?limit=1000" });
            if (resRates.status || resRates.success) {
                setExistingRates(resRates.data);
            }

            // ⭐ 4. Load Current Rate Data (Adjusted for your JSON structure)
            const resSingle = await Handler({ method: "get", url: `/rate/view.php?id=${id}` });
            if (resSingle.status || resSingle.success) {
                const { rate_info, rate_breakdown } = resSingle.data;

                // Form flat-ah irukuradhala nested data-va spread panni set panrom
                setForm({
                    customer_id: rate_info?.customer_id || "",
                    vehicle_id: rate_info?.vehicle_id || "",
                    lorry_type: rate_info?.lorry_type || "",
                    ...rate_breakdown // rate_breakdown-la iruka ellathaiyum spread pannidum
                });
            }

        } catch (err) {
            console.error(err);
        }
        dispatch(loadingFalse());
    };

    useEffect(() => { loadInitialData(); }, [id]);

    useEffect(() => {
        if (form.customer_id && existingRates.length > 0) {
            const selectedCustomer = customers.find(c => String(c.value) === String(form.customer_id));
            const customerName = selectedCustomer ? selectedCustomer.label : "";

            const usedVehicleLabels = existingRates
                .filter(r => String(r.customer_name) === String(customerName) && String(r.id) !== String(id))
                .map(r => String(r.vehicle_number));

            const filtered = vehicles.filter(v => {
                const vNumber = v.label.split(' (')[0];
                return !usedVehicleLabels.includes(vNumber);
            });

            setDisplayVehicles(filtered);
        }
    }, [form.customer_id, existingRates, vehicles, customers, id]);

    const handleChange = e => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        dispatch(loadingTrue());

        const res = await Handler({
            method: "post",
            url: "/rate/update.php",
            data: { ...form, id }
        });

        if (res.status || res.success) {
            toast.success(res.message || "Pricing updated successfully");
            setTimeout(() => reloadWindowToPath("/rates"), 1000);
        } else toast.error(res.message || "Error updating rate");

        dispatch(loadingFalse());
    };

    return (
        <div className="page-card">
            <div className="page-header">
                <h4>Edit Rate</h4>
            </div>

            <form onSubmit={handleSubmit} className="form-grid">
                <div className="form-group">
                    <label>Select Customer</label>
                    <Select
                        options={customers}
                        value={customers.find(c => String(c.value) === String(form.customer_id)) || null}
                        placeholder="Choose active customer"
                        onChange={(opt) => setForm({ ...form, customer_id: opt.value })}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Select Vehicle</label>
                    <Select
                        options={displayVehicles}
                        value={vehicles.find(v => String(v.value) === String(form.vehicle_id)) || null}
                        placeholder="Select Vehicle"
                        onChange={(opt) => setForm({
                            ...form,
                            vehicle_id: opt ? opt.value : "",
                            lorry_type: opt ? opt.lorry_type : ""
                        })}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>GST %</label>
                    <input name="gst_percent" value={form.gst_percent} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Normal Hrs Rate</label>
                    <input name="normal_hrs" type="number" step="0.01" className="form-control" value={form.normal_hrs} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Normal Hrs OT Rate</label>
                    <input name="normal_hrs_ot" value={form.normal_hrs_ot} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>After Office Hrs Rate</label>
                    <input name="after_office_hrs" value={form.after_office_hrs} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Office Hrs OT Rate</label>
                    <input name="offz_hrs_ot" value={form.offz_hrs_ot} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Holiday Rate</label>
                    <input name="holiday" value={form.holiday} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Holiday OT Rate</label>
                    <input name="holiday_ot" value={form.holiday_ot} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group full">
                    <button className="btn add-btn-add" disabled={loading}>
                        {loading ? "Updating..." : "Update Rate"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EditRate;